module.exports = __webpack_public_path__ + "img/detail_banner_cyt.146b9403.png";